import React, { Component } from 'react';
import { Route, BrowserRouter, Redirect, HashRouter } from 'react-router-dom';
import {Alert, Spinner} from 'reactstrap';
import './static/Materia.bootstrap.min.css'; //Bootstrap 4 material theme
import './static/fontawesome-free-5.8.1-web/css/all.min.css';
import Logic from './Logic';
import Edit from './Pages/Edit/Edit';
import Users from './Pages/Users/Users';
import Create from './Pages/Create/Create';
import Error from './Pages/Error/Error';
import Report from './Pages/Report/Report';
import Vendors from './Pages/Vendors/Vendors';
import MyCandidates from './Pages/MyCandidates/MyCandidates';
import Sms from './Pages/Sms/Sms';
import MainMenu from './Components/MainMenu/MainMenu';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import Loading from './Components/Loading/Loading';
import Notification from './Components/Notification/Notification';
import styles from './App.css';

class App extends Component {
  constructor(props){
    super(props);
    this.onInitChanged = this.onInitChanged.bind(this);
    this.toggleSpinner = this.toggleSpinner.bind(this);
    this.notify = this.notify.bind(this);
    this.state = { init: null, env: null, showSpinner:false, notificationSuccess:false, notificationMessage:null };
  }

  componentWillUnmount(){
  }

  componentDidMount(prevProps, prevState, snapshot){
    let logic = new Logic();
    let baseURL = logic.getBaseRedirectUrl(); //window.location.hostname == 'localhost' ? 'http://apps/ReliabilityCheck/' : process.env.PUBLIC_URL + '/';
    logic.getInit((response) => {
      if(response.data.candidate){
        sessionStorage.setItem('authKey',response.data.candidate.authKey);
      }
      this.setState({init: {...response.data}, validSms: response.success, unknown: response.message == 'Unknown', errorMessage: response.message,
        env: response.data.environment === 'DEV' ? <Alert className="environment text-center" color="success">סביבת פיתוח</Alert> : 
        response.data.environment === 'QA' ? <Alert className="environment text-center" color="warning">סביבת בדיקות</Alert> : null},
        (newState) =>{
          if(response.data.admin){
            document.title = 'מערכת זקיף משרד הביטחון - ממשק מנהלן';
            window.location = baseURL + '#/users';
          }else if(response.data.user){
            document.title = 'מערכת זקיף משרד הביטחון - ממשק נאמן ביטחון';
            window.location = baseURL + '#/mycandidates';
          }else if(response.data.candidate && response.success){ //verifiyed candidates are redirected to edit page
            window.location = baseURL + '#/edit';
          }
          else if(response.data.candidate && !response.success){ //unverifiyed candidates are redirected to sms page
            window.location = baseURL +  '#/login';
          }
          else{ // if(!response.success){
            document.title = 'מערכת זקיף להגשת בקשות סיווג ביטחוני - משרד הביטחון';
            window.location = baseURL + '#/error';
          }
        });
    });
  }

  onInitChanged(init, otherState={}){
    this.setState({init:init, ...otherState});
  }

  toggleSpinner(){
    const toggleState = !this.state.showSpinner;
    this.setState({...this.state, showSpinner: toggleState});
    setTimeout(()=>{
      //fallback to case when ajax fails or something like that
      if (this.state.showSpinner) {
        this.setState({...this.state, showSpinner: !this.state.showSpinner});
      }
    },5 * 1000);
  }

  notify(success, message){
    this.setState({ notificationSuccess:success, notificationMessage:message }, () => {
      setTimeout(() => {
          this.setState({notificationSuccess:false, notificationMessage: null });
      }, 3 * 1000);
    });
  }

  render() {
    return (
      <>
      {this.state.init ? 
      <HashRouter>
        <div className={'container-fluid app-background' + (this.state.init.environment ? ' ' + this.state.init.environment : '')}>
          <Loading isOpen={this.state.showSpinner}/>
            <div className="app-container">
              {this.state.env}
                <MainMenu init={this.state.init} validSms={this.state.validSms} toggleSpinner={this.toggleSpinner} notify={this.notify}/>
                <Header init={this.state.init} validSms={this.state.validSms} toggleSpinner={this.toggleSpinner} notify={this.notify}/>
                <Notification success={this.state.notificationSuccess} message={this.state.notificationMessage}/>

                {this.state.init.user ?
                <div>
                  <Route path="/edit/:authKey" exact render={(route) => <Edit init={this.state.init} {...route} {...this.props} onInitChanged={this.onInitChanged} toggleSpinner={this.toggleSpinner} notify={this.notify}/> }/> {/*  link from table */}
                  <Route path="/mycandidates" exact component={(route) => <MyCandidates {...route} init={this.state.init} {...this.props} onInitChanged={this.onInitChanged} toggleSpinner={this.toggleSpinner} notify={this.notify}/>}/>
                </div>
                :null}

                {this.state.init.admin ? 
                <div>
                  <Route path="/users" exact render={(route) => <Users init={this.state.init} {...route} {...this.props} toggleSpinner={this.toggleSpinner} notify={this.notify}/>}/>
                </div>
                : null}              
                
                {/* for unknown users show only the error page */}
                {this.state.unknown ? <Route component={(route) => <Error {...route} {...this.props} message={this.state.errorMessage} toggleSpinner={this.toggleSpinner} notify={this.notify}/> }/>
                : null
                }
                
                {this.state.init.candidate ? 
                <>
                  {this.state.validSms ? 
                  <>
                  {/* known candidates with valid sms cert */}
                    <Route path="/edit" exact render={(route) => <Edit init={this.state.init} {...route} {...this.props} toggleSpinner={this.toggleSpinner} notify={this.notify}/>}/>
                    <Route path="/login" component={(route) => <Sms init={this.state.init} {...route} {...this.props} onAuthenticated={this.onInitChanged} notify={this.notify}/> }/>
                  </> : 
                  <>
                  {/* known candidates with invalid sms cert */}
                    <Route path="/login" component={(route) => <Sms init={this.state.init} {...route} {...this.props} onAuthenticated={this.onInitChanged} notify={this.notify}/> }/>
                  </> }
                  
                </> : null}
              </div>
              {/* {this.state.env} */}
              <Footer/>
        </div>
      </HashRouter>
      : <div style={{marginTop:'20%'}}>
            <Spinner color="primary" style={{width:'4rem', height:'4rem', margin:'auto auto auto auto', display:'block'}}/>
            <div style={{margin:'auto auto auto auto', display:'block', textAlign:'center'}}>האתר בטעינה...</div>
        </div>}
      </>
    );
  }
}
export default App;